import type { CSSProperties } from 'react'
import { cx } from '@shared/lib/cx'
import { skeleton } from './Skeleton.css'

export type SkeletonProps = {
  width?: string | number
  height?: string | number
  radius?: string
  className?: string
}

export function Skeleton({ width = '100%', height = 12, radius, className }: SkeletonProps) {
  const style: CSSProperties = { width, height }
  if (radius) {
    style.borderRadius = radius
  }
  return <span className={cx(skeleton, className)} style={style} />
}
